import { type UploadFileMessage, strings } from "@quickpoint.me/shared";
import { useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { HostId } from "../state/atoms";
import { Authorization } from "../state/authAtoms";
import { OwnerName } from "../state/authSelectors";
import { TogglePanelFor } from "../state/selectors";
import { StackId } from "../state/stackSelectors";
import { ShowFileUploader } from "../state/uiAtoms";
import { sendUploadFiles } from "../lib/messageBus";

function FileDrop() {
	const authorization = useRecoilValue(Authorization);
	const ownerName = useRecoilValue(OwnerName);
	const stackId = useRecoilValue(StackId);
	const togglePanelFor = useSetRecoilState(TogglePanelFor);
	const showFileUploader = useRecoilValue(ShowFileUploader);
	const hostId = useRecoilValue(HostId);

	useEffect(() => {
		const handleDrop = (e: DragEvent) => {
			if (!authorization.isLoggedIn) {
				window.alert("Please login first");
				return;
			}
			if (!e.dataTransfer || !authorization.uid) return;

			if (!showFileUploader) togglePanelFor("files");

			const files = e.dataTransfer.files;

			const message: UploadFileMessage = {
				hostId,
				action: strings.messages.fileUpload,
				ownerId: authorization.uid,
				ownerName,
				payload: files,
				type: "QP",
				stackId,
			};
			sendUploadFiles(message);
		};
		function preventDefaults(e: Event) {
			e.preventDefault();
			e.stopPropagation();
		}

		const dropZones = document.getElementsByClassName(
			strings.css.fileDropZone,
		) as HTMLCollection;
		for (const dropZone of Array.from(dropZones)) {
			if (!dropZone) continue;
			// @ts-expect-error: but i can?
			dropZone.addEventListener("drop", handleDrop, false);

			for (const eventName of ["dragenter", "dragover", "dragleave", "drop"]) {
				dropZone.addEventListener(eventName, preventDefaults, false);
			}
		}

		return () => {
			for (const dropZone of Array.from(dropZones)) {
				// @ts-expect-error: but i can?
				dropZone.removeEventListener("drop", handleDrop, false);
				// ["dragenter", "dragover", "dragleave", "drop"].forEach(eventName => {
				//   dropZone.removeEventListener(eventName, preventDefaults, false);
				// });
			}
		};
	}, [
		authorization,
		showFileUploader,
		hostId,
		ownerName,
		stackId,
		togglePanelFor,
	]);

	return <></>;
}

export default FileDrop;
